export const WINNER_KEYS = {
  JACKPOT: 'winner/jackpot',
} as const
